import { VALID_WALLET_TYPES } from "@swiggy-private/payment-types";

export interface WalletTestIds {
    CONTAINER: string;
    ICON: string;
    NAME: string;
    CIRCLE_LOADER: string;
    TICK: string;
    LINK_ACCOUNT: string;
    DIALOG_HEADER_ICON: string;
    DIALOG_CONTENT: {
        WRAPPER: string;
        TEXT: string;
        SUB_TEXT: string;
        MOBILE: string;
    };
    PAY_BUTTON: string;
    WALLET_BALANCE: string;
    RETRY_LINK_ACCOUNT: string;
    ADD_MONEY_INPUT: string;
    ADD_MONEY_BUTTON: string;
    DISABLE_MESSAGE: string;
    ALERT_MESSAGE: string;
}

const WALLET_TEST_ID_PREFIX = {
    [VALID_WALLET_TYPES.AMAZONPAY]: "ap",
    [VALID_WALLET_TYPES.AMAZONPAYWEB]: "apb",
    [VALID_WALLET_TYPES.FREECHARGE]: "fc",
    [VALID_WALLET_TYPES.MOBIKWIK]: "mk",
    [VALID_WALLET_TYPES.PAYTM]: "ptm",
    [VALID_WALLET_TYPES.PHONEPE]: "pp",
};

const getWalletPrefix = (paymentCode: string): string => {
    const walletCode = paymentCode.toUpperCase() as VALID_WALLET_TYPES;
    return WALLET_TEST_ID_PREFIX[walletCode] ?? "wal";
};

export const getWalletTestIds = (paymentCode: string): WalletTestIds => {
    const walletPrefix = getWalletPrefix(paymentCode);
    const dialogHeaderPrefix = `${walletPrefix}_dh`;
    const dialogContentPrefix = `${walletPrefix}_dc`;

    return {
        CONTAINER: `${walletPrefix}_container`,
        ICON: `${walletPrefix}_icon`,
        NAME: `${walletPrefix}_name`,
        CIRCLE_LOADER: `${walletPrefix}_circle_loader`,
        TICK: `${walletPrefix}_tick`,
        LINK_ACCOUNT: `${walletPrefix}_link_acc`,
        DIALOG_HEADER_ICON: `${dialogHeaderPrefix}_icon`,
        DIALOG_CONTENT: {
            WRAPPER: `${dialogContentPrefix}`,
            TEXT: `${dialogContentPrefix}_text`,
            SUB_TEXT: `${dialogContentPrefix}_subtext`,
            MOBILE: `${dialogContentPrefix}_mobile`,
        },
        PAY_BUTTON: `${walletPrefix}_pay_btn`,
        WALLET_BALANCE: `${walletPrefix}_bal`,
        RETRY_LINK_ACCOUNT: `${walletPrefix}_retry`,
        ADD_MONEY_INPUT: `${walletPrefix}_add_money`,
        ADD_MONEY_BUTTON: `${walletPrefix}_add_money_btn`,
        DISABLE_MESSAGE: `${walletPrefix}_disable_msg`,
        ALERT_MESSAGE: `${walletPrefix}_alert_msg`,
    };
};
